<template>
  <div class="installment-form">
    <b-form
      ref="form"
      lazy-validation
      class="row"
    >
      <b-container class="bv-example-row">
        <b-row>
          <b-col md="4">
            <InputField
              id="code"
              label="Mã tài khoản"
              v-model="formData.code"
              placeholder="Nhập mã"
              :error="errors.code"
            />

            <InputField
              id="name"
              label="Tên tài khoản"
              v-model="formData.name"
              placeholder="Nhập tên"
              :error="errors.name"
            />

            <InputField
              id="phone"
              label="Điện thoại"
              v-model="formData.phone"
              placeholder="Nhập điện thoại"
              :error="errors.phone"
            />

            <InputField
              id="address"
              label="Địa chỉ"
              v-model="formData.address"
              placeholder="Nhập địa chỉ"
              :error="errors.address"
            />
          </b-col>
          <b-col md="4"></b-col>
          <b-col md="4"></b-col>
        </b-row>
      </b-container>
    </b-form>
  </div>
</template>

<script>
import InputField from './InputField.vue';

export default {
  name: 'InstallmentForm',
  components: {
    InputField,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

